'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _gsap = require('gsap');

var _gsap2 = _interopRequireDefault(_gsap);

var _ScrollTrigger = require('gsap/ScrollTrigger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*----------------------------
Scripts
----------------------------*/

document.addEventListener('DOMContentLoaded', function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(event) {
    var articleProgressBar;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // GSAP Plugins
            _gsap2.default.registerPlugin(_ScrollTrigger.ScrollTrigger);

            /*----------------------------
            Progress Bar
            ----------------------------*/
            articleProgressBar = document.querySelector('.article-sticky-nav__progress');


            if (articleProgressBar) {
              _gsap2.default.to(articleProgressBar, {
                width: '100%',
                scrollTrigger: {
                  markers: false,
                  trigger: '.article-container',
                  scrub: true,
                  start: 'top top',
                  end: 'bottom top'
                }
              });
            }

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());